import { isSupportedLocale, type SupportedLocale } from '../../../i18n/types'

// localStorage key for persisting the user's language preference across sessions
// (and across logout), so the public login screen can render in the chosen locale
// before the authenticated PreferencesProvider has had a chance to load.
export const LOCALE_STORAGE_KEY = 'familyPortal.locale'

function getStorage(): Storage | null {
  try {
    if (typeof window === 'undefined') return null
    return window.localStorage
  } catch {
    return null
  }
}

export function readStoredLocale(): SupportedLocale | null {
  const storage = getStorage()
  if (!storage) return null
  try {
    const raw = storage.getItem(LOCALE_STORAGE_KEY)
    return isSupportedLocale(raw) ? raw : null
  } catch {
    return null
  }
}

export function writeStoredLocale(locale: SupportedLocale): void {
  const storage = getStorage()
  if (!storage) return
  try {
    storage.setItem(LOCALE_STORAGE_KEY, locale)
  } catch {
    // Ignore — quota, private mode, or disabled storage are non-fatal here.
  }
}
